import type { VideoPlaylistFilters, VideoPlaylistOptions } from './types';

import { loadEntitiesByClassification } from '@apis/editorial';

export const fetchVideos = (
  {
    options,
    filters,
    limit,
    offset,
  }: { options: VideoPlaylistOptions; filters: VideoPlaylistFilters; limit: number; offset: number },
  signal: AbortSignal,
) =>
  loadEntitiesByClassification(
    {
      type: 'videostory',
      ['param.attributes.main.competition']: window.competitionId,
      ['param.attributes.main.kind']: options.kinds,
      ['param.attributes.hashtags']: options.hashtags,
      ['param.attributes.sections']: options.sections,
      ['param.attributes.main.season']: options.season,
      ['param.attributes.main.phase']: options.phase,
      ['param.attributes.workFolder']: options.workFolder,
      startDate: options.startDate,
      endDate: options.endDate,
      ['param.attributes.footballEntities.team.teamId']: filters?.team?.id,
      ['param.attributes.footballEntities.matchday.matchdayId']: filters?.matchday?.id,
      limit,
      offset,
      sorting: '-attributes.firstPublicationDate',
    },
    undefined,
    signal,
  );
